import { render, staticRenderFns } from "./Footing.vue?vue&type=template&id=293efe18&"
import script from "./Footing.vue?vue&type=script&lang=js&"
export * from "./Footing.vue?vue&type=script&lang=js&"
import style0 from "./Footing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports